import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import { useServerIds } from "hooks/search";
import { useNavigateToSearch } from "hooks/navigation";
import { useLocation } from "react-router";

export const BackToResults = () => {
  const currentLocation = useLocation();
  const isPlanPeek = currentLocation.pathname.endsWith("/search");
  const navigateToSearch = useNavigateToSearch();
  const { searchId } = useServerIds();

  return (
    <IconButton
      data-testid="back-to-results"
      onClick={() => {
        if (searchId !== null) {
          navigateToSearch(searchId);
        }
      }}
      sx={{ color: "action.primary" }}
    >
      {isPlanPeek ? <CloseIcon /> : <ArrowBackIcon />}
    </IconButton>
  );
};
